import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { FullWidthWrapper } from 'legacyComponents/styled/lib';
import { Button, Spinner } from 'components';
import { Section } from 'legacyComponents/layout/section';
import { clientStore } from 'apps/client/app';
import { ButtonsWrapper } from 'apps/repository/styles';

import { ResolutionWrapper } from 'apps/project/tabs/conflicts/styles';

import { ConflictsManager } from 'apps/project/tabs/conflicts/appManager';
import { StepColumn } from 'apps/project/tabs/conflicts/views/stepsColumn';
import { LocalConflict } from 'apps/project/tabs/conflicts/views/localConflict';
import { RemoteConflict } from 'apps/project/tabs/conflicts/views/remoteConflict';

@withNamespaces()
@observer
export class ConflictsPage extends React.Component {
  UNSAFE_componentWillMount = () => {
    const { params } = this.props;
    this.appManager = new ConflictsManager(null, { params });
  };

  render() {
    const { preQueriedConflicts, conflicts, activeConflict } = this.appManager;
    if (!preQueriedConflicts) {
      if (this.appManager.loading) {
        return <Spinner margin='30px auto 10px' />;
      }
    }
    if (['xs', 's', 'm'].includes(clientStore.activeBreakPoint)) {
      return (
        <FullWidthWrapper marginBottom='90px'>
          <Section
            title='The following conflicts need resolving'
            subTitle='(before finalising your contribution)'
          >
            <p>
              Conflict Resolution is not supported on small screen sizes. If you
              are on a laptop or desktop, try going fullscreen.
            </p>
          </Section>
        </FullWidthWrapper>
      );
    }
    const { route } = clientStore.routerStore;
    const abortRouteName = route.name.replace('.conflicts', '.files');
    const abortRouteParams = route.params;
    const repoAppManager = clientStore.context.get('repoAppManager');

    return (
      <FullWidthWrapper marginBottom='90px'>
        <Section
          title='The following conflicts need resolving'
          subTitle='(before finalising your contribution)'
        >
          <ButtonsWrapper>
            <Link name={abortRouteName} params={abortRouteParams}>
              <Button
                text='Abort Contribution'
                variant='destructive'
                size='small'
                outline
                onClick={() => repoAppManager.CancelContribution()}
              />
            </Link>
          </ButtonsWrapper>
          <ResolutionWrapper>
            <StepColumn
              conflicts={conflicts}
              activeConflict={activeConflict}
              manager={this.appManager}
            />
            <LocalConflict
              conflicts={conflicts}
              activeConflict={activeConflict}
              manager={this.appManager}
            />
            <RemoteConflict
              conflicts={conflicts}
              activeConflict={activeConflict}
              manager={this.appManager}
            />
          </ResolutionWrapper>
        </Section>
      </FullWidthWrapper>
    );
  }
}

ConflictsPage.propTypes = {
  params: PropTypes.object,
  project: PropTypes.object,
  repoManager: PropTypes.object,
  projectManager: PropTypes.object,
  t: PropTypes.func,
};
